import { getDiscoCompanyMenuItems } from "../../components/AdminCompanySelect/DiscoCompanyMenuItems";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Stack,
  Tooltip,
} from "@mui/material";
import { createColumnHelper } from "@tanstack/react-table";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import jsPDF from "jspdf";
import { useEffect, useState, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import { cfpBaseUrl } from "../../network/urls";
import { openJsPdfInNewTab, convertDate,
  convertDatewithTime,
  convertToMillions,
  numberFormatting,
  officeName,
  subdivisionName,
  getName,
} from "../../services/Functions";
import "../../style/common.scss";
import ReportExportButtons from "./components/ReportExportButtons";
import "./reportPageLayout.scss";
import "./ChangeOfAttributesStatusReport.scss";
import "./FeederLossesReport.scss";
import {
  renderCircleValue,
  renderDivisionValue,
  renderSubDivisionValue,
} from "./coaHierarchySelectRenderers";
import eOpsLogo from "../../images/eops.png";
import mepcoLogo from "../../images/mepcoLogo.png";
import XLSX, { boldDomTheadRows } from "utils/xlsxStyled";
import { saveAs } from "file-saver";
import AppLoader from '../../components/AppLoader/AppLoader';
import FESCOLOGO from "../../images/DISCO Logos/FESCO.png";
import GEPCOLOGO from "../../images/DISCO Logos/GEPCO.png";
import HESCOLOGO from "../../images/DISCO Logos/HESCO.png";
import IESCOLOGO from "../../images/DISCO Logos/IESCO.png";
import MEPCOLOGO from "../../images/DISCO Logos/MEPCO.png";
import LESCOLOGO from "../../images/DISCO Logos/LESCO.png";
import PESCOLOGO from "../../images/DISCO Logos/PESCO.png";
import QESCOLOGO from "../../images/DISCO Logos/QESCO.png";
import SEPCOLOGO from "../../images/DISCO Logos/SEPCO.png";
import TESCOLOGO from "../../images/DISCO Logos/TESCO.png";
import HAZECOLOGO from "../../images/DISCO Logos/HAZECO.jpg";
import pitcLogo from "../../images/pitc.png";
import { resolveOfficeCodeForAdmin, getInitialAdminOfficeCode, getEffectiveAdminCompanyCode, resolveReportGoOfficeCode } from "../../utils/adminCompany";
const FeederLossesReport = () => {
  const columnHelper = createColumnHelper();
  const tableRef = useRef(null);
  const [previousMonth, setPreviousMonth] = useState("");
  const [assmntBatchWise, setAssmntBatchWise] = useState([]);
  const { token, code, name, roleName, roleTypeName, cscID, cfcLevelId, selectedAdminCompanyCode } =
    useSelector((state) => state.auth);
  const companyCode = code.slice(0, 2);
  const offCode = code;
  const [loading, setLoading] = useState(false);
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || []
  );
  const [selectedCompanyCode, setSelectedCompanyCode] = useState(
    getInitialAdminOfficeCode(code, selectedAdminCompanyCode),
  );

  const formattedAssmntBatchWise = assmntBatchWise.map((batch) => {
    let formattedBatch = {};
    Object.keys(batch).forEach((key) => {
      formattedBatch[key] =
        batch[key] != "Total" ? numberFormatting(batch[key]) : batch[key];
    });
    return formattedBatch;
  });
  // const { officeCode: offCode } = useSelector(state => state.officeCode)
  const [chartOptionsBilling, setChartOptionsBilling] = useState({
    chart: {
      type: "bar",
      width: null,
      height: "294",
      padding: "auto",
      marginBottom: "30",
      marginTop: "0",
      marginLeft: "60",
      backgroundColor: "transparent",
    },
    title: {
      text: "",
      align: "left",
    },
    subtitle: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: [
        "Total",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "12",
        "13",
        "...",
      ],
      title: {
        useHTML: true,
        text: '<span style="letter-spacing: 7.5px; color:#BF0F15; ">Batch Number</span>', // Adjust letter-spacing here
        x: 10,
      },
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: {
        text: "MRs.",
        align: "low",
        margin: -15,
        style: {
          color: "#BF0F15",
        },
        x: -45,
      },
      labels: {
        overflow: "justify",
      },
      gridLineWidth: 0,
    },
    tooltip: {
      useHTML: true,
      headerFormat:
        '<span style="font-size: 12px; color: #000;">Batch: {point.key}</span><br>',
      pointFormatter: function () {
        return `<span style="color:${this.color}; font-weight: bold;">Amount: ${
          this.series.name
        } </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MRs.</span>`;
      },
    },
    plotOptions: {
      bar: {
        borderRadius: "50%",
        dataLabels: {
          enabled: false,
        },
        groupPadding: 0.075,
        borderWidth: 0,
      },
      series: {
        pointWidth: 10,
      },
    },
    legend: {
      layout: "vertical",
      align: "right",
      verticalAlign: "bottom",
      x: -40,
      y: 80,
      floating: true,
      borderWidth: 1,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
      shadow: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "",
        color: "#006ad1",
        data: [
          10000, 727, 3202, 721, 632, 727, 3202, 721, 632, 727, 721, 632, 727,
          7210,
        ],
      },
    ],
  });

  const [dateFrom, setDateFrom] = useState("");
  const [reportData, setReportData] = useState([]);
  const [data, setData] = useState([]);
  const [billingChartXType, setBillingChartXType] = useState(1);
  const [billingChartYType, setBillingChartYType] = useState(1);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [filteredDivisions, setFilteredDivisions] = useState([]);
  const [filteredSubDivisions, setFilteredSubDivisions] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [circleCode, setCircleCode] = useState("");
  const [circleName, setCircleName] = useState("");
  const [officeCode, setOfficeCode] = useState("");
  useEffect(() => {
    if (String(code) === "10" && selectedAdminCompanyCode) {
      const company = String(selectedAdminCompanyCode);
      setSelectedCompanyCode(company);
      setOfficeCode(company);
    }
  }, [code, selectedAdminCompanyCode]);

  useEffect(() => {
    if (String(code) !== "10") return;
    if (circleCode || selectedDivision || selectedSubDivision) return;
    const company = getEffectiveAdminCompanyCode(
      code,
      selectedCompanyCode,
      selectedAdminCompanyCode,
    );
    if (company) {
      setOfficeCode(company);
    }
  }, [
    code,
    selectedCompanyCode,
    selectedAdminCompanyCode,
    circleCode,
    selectedDivision,
    selectedSubDivision,
  ]);
  const [officeName, setOfficeName] = useState("");
  const [filteredCircles, setFilteredCircles] = useState([]);
  const [hierarchy, setHierarchy] = useState("");
  const [isGoDisabled, setIsGoDisabled] = useState(true);
  const [lastAppliedFilters, setLastAppliedFilters] = useState(null);
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  const [currentBillingStats, setCurrentBillingStats] = useState({
    batches: [],
    amountsBatchWise: [],
    unitsBatchWise: [],
    categories: ["Total", "Dom.", "Com.", "Ind.", "Arg.", "Oth."],
    amountsCategoryWise: [],
  });
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Adding 1 because months are 0-indexed
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // Fetch subDivisions for code == 10
  useEffect(() => {
    if (code == 10 && selectedCompanyCode) {
      const fetchSubDivisions = async () => {
        setLoading(true);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        const formdata = new FormData();
        formdata.append("companyCode", selectedCompanyCode);
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: formdata,
          redirect: "follow",
        };
        try {
          const response = await fetch(
            cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
            requestOptions
          );
          if (response.ok) {
            const result = await response.json();
            if (result.status === "200") {
              setSubDivisions(result.message);
              setApiData(result.message);
              // Populate circles
              const circles = result.message.reduce((acc, curr) => {
                if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                  acc.push({
                    circleCode: curr.circleCode,
                    circleName: curr.circleName,
                    companyCode: curr.companyCode,
                  });
                }
                return acc;
              }, []);
              setFilteredCircles(circles);
            } else {
              setSubDivisions([]);
              setFilteredCircles([]);
            }
          } else {
            throw new Error(`Request failed with status ${response.status}`);
          }
        } catch (error) {
          setSubDivisions([]);
          setFilteredCircles([]);
        } finally {
          setLoading(false);
        }
      };
      fetchSubDivisions();
    } else if (code != 10) {
      // For code != 10, populate circles from localStorage subDivisions
      const circles = subDivisions.reduce((acc, curr) => {
        if (!acc.some((item) => item.circleCode === curr.circleCode)) {
          acc.push({
            circleCode: curr.circleCode,
            circleName: curr.circleName,
            companyCode: curr.companyCode,
          });
        }
        return acc;
      }, []);
      setFilteredCircles(circles);
    }
  }, [code, selectedCompanyCode, token, cfpBaseUrl]);

  const handleChangeCompany = async (e) => {
    const selectedCompany = e.target.value;
    setSelectedCompanyCode(selectedCompany);
    setOfficeCode(selectedCompany);
    setOfficeName(getCompanies(selectedCompany) || "");

    if (code == 10 && selectedCompany) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompany);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            // Reset dropdowns
            setCircleCode("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setCircleName("");
            setFilteredDivisions([]);
            setFilteredSubDivisions([]);

            // Populate circles
            const circles = result.message.reduce((acc, curr) => {
              if (!acc.some((item) => item.circleCode === curr.circleCode)) {
                acc.push({
                  circleCode: curr.circleCode,
                  circleName: curr.circleName,
                  companyCode: curr.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredCircles(circles);
          } else {
            setSubDivisions([]);
            setFilteredCircles([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredCircles([]);
      } finally {
        setLoading(false);
      }
    } else if (!selectedCompany) {
      // Reset when no company is selected
      setOfficeName("PITC");
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setCircleName("");
      setFilteredDivisions([]);
      setFilteredSubDivisions([]);
      setFilteredCircles([]);
      setSubDivisions([]);
      setApiData([]);
    }
  };

  const handleCircleChange = async (event) => {
    const selectedCircleCode = event.target.value
      ? parseInt(event.target.value)
      : "";
    if (code == 10 && selectedCircleCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("circleCode", selectedCircleCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode(selectedCircleCode);
            setOfficeCode(selectedCircleCode);
            const circle = filteredCircles.find(
              (circle) => circle.circleCode === selectedCircleCode
            );
            const circleName = circle?.circleName || "";
            setOfficeName(circleName.concat(" Circle"));
            setCircleName(circleName);
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message
              .filter((item) => item.circleCode === selectedCircleCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (division) => division.divisionCode === item.divisionCode
                  )
                ) {
                  acc.push({
                    divisionCode: item.divisionCode,
                    divisionName: item.divisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (code == 10 && !selectedCircleCode && selectedCompanyCode) {
      // Handle "All Circle" selection for code == 10
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setCircleCode("");
            setOfficeCode(selectedCompanyCode);
            setOfficeName(getCompanies(selectedCompanyCode));
            setCircleName("");
            setSelectedDivision("");
            setSelectedSubDivision("");
            setFilteredSubDivisions([]);

            // Populate divisions
            const uniqueDivisions = result.message.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          } else {
            setSubDivisions([]);
            setFilteredDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedCircleCode) {
      setCircleCode(selectedCircleCode);
      setOfficeCode(selectedCircleCode);
      const circle = filteredCircles.find(
        (circle) => circle.circleCode === selectedCircleCode
      );
      const circleName = circle?.circleName || "";
      setOfficeName(circleName.concat(" Circle"));
      setCircleName(circleName);
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter((item) => item.circleCode === selectedCircleCode)
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    } else {
      // Handle "All Circle" for code != 10
      setCircleCode("");
      setSelectedDivision("");
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      if (roleTypeName == "Technical") {
        if (offCode) {
          setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
          let officeName = getName(
            String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
            subDivisions
          );
          setOfficeName(officeName.concat(" Region"));
          setCircleName("");
          const circles = subDivisions.reduce((acc, curr) => {
            if (!acc.some((item) => item.circleCode === curr.circleCode)) {
              acc.push({
                circleCode: curr.circleCode,
                circleName: curr.circleName,
                companyCode: curr.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredCircles(circles);
          const uniqueDivisions = subDivisions.reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
          setFilteredDivisions(uniqueDivisions);
        }
      } else if (roleTypeName == "Commercial") {
        if (cfcLevelId == 2) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 2));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        } else if (cfcLevelId == 3) {
          if (offCode) {
            setOfficeCode(offCode.toString().slice(0, 3));
            let offName = cscID;
            setOfficeName(offName);
            setHierarchy(cfcLevelId);
            const uniqueDivisions = subDivisions.reduce((acc, item) => {
              if (
                !acc.some(
                  (division) => division.divisionCode === item.divisionCode
                )
              ) {
                acc.push({
                  divisionCode: item.divisionCode,
                  divisionName: item.divisionName,
                  companyCode: item.companyCode,
                });
              }
              return acc;
            }, []);
            setFilteredDivisions(uniqueDivisions);
          }
        }
      }
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("divisionCode", selectedDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedDivision(selectedDivisionCode);
            setOfficeCode(selectedDivisionCode);
            const division = filteredDivisions.find(
              (division) => division.divisionCode === selectedDivisionCode
            );
            const divisionName = division?.divisionName || "";
            setOfficeName(divisionName.concat(" Division"));
            setSelectedSubDivision("");
            const uniqueSubDivisions = result.message
              .filter((item) => item.divisionCode == selectedDivisionCode)
              .reduce((acc, item) => {
                if (
                  !acc.some(
                    (sub) => sub.subDivisionCode === item.subDivisionCode
                  )
                ) {
                  acc.push({
                    subDivisionCode: item.subDivisionCode,
                    subDivisionName: item.subDivisionName,
                    companyCode: item.companyCode,
                  });
                }
                return acc;
              }, []);
            setFilteredSubDivisions(uniqueSubDivisions);
          } else {
            setSubDivisions([]);
            setFilteredSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
        setFilteredSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedDivisionCode) {
      setSelectedDivision(selectedDivisionCode);
      setOfficeCode(selectedDivisionCode);
      const divisionName =
        filteredDivisions.find(
          (division) => division.divisionCode === selectedDivisionCode
        )?.divisionName || "";
      setOfficeName(divisionName.concat(" Division"));
      setSelectedSubDivision("");
      const uniqueSubDivisions = subDivisions
        .filter((item) => item.divisionCode == selectedDivisionCode)
        .reduce((acc, item) => {
          if (
            !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
          ) {
            acc.push({
              subDivisionCode: item.subDivisionCode,
              subDivisionName: item.subDivisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredSubDivisions(uniqueSubDivisions);
    } else {
      setSelectedDivision("");
      setOfficeCode(circleCode ? circleCode : offCode);
      let officeName = getName(
        circleCode ? circleCode.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Circle"));
      setSelectedSubDivision("");
      setFilteredSubDivisions([]);
      const uniqueDivisions = subDivisions
        .filter(
          (item) => item.circleCode == (circleCode ? circleCode : offCode)
        )
        .reduce((acc, item) => {
          if (
            !acc.some((division) => division.divisionCode === item.divisionCode)
          ) {
            acc.push({
              divisionCode: item.divisionCode,
              divisionName: item.divisionName,
              companyCode: item.companyCode,
            });
          }
          return acc;
        }, []);
      setFilteredDivisions(uniqueDivisions);
    }
  };

  const handleSubDivisionChange = async (e) => {
    const selectedSubDivisionCode = parseInt(e.target.value);
    if (code == 10 && selectedSubDivisionCode && selectedCompanyCode) {
      setLoading(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      const formdata = new FormData();
      formdata.append("companyCode", selectedCompanyCode);
      formdata.append("subDivisionCode", selectedSubDivisionCode);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      try {
        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
          requestOptions
        );
        if (response.ok) {
          const result = await response.json();
          if (result.status === "200") {
            setSubDivisions(result.message);
            setApiData(result.message);

            setSelectedSubDivision(selectedSubDivisionCode);
            setOfficeCode(selectedSubDivisionCode);
            const subDivision = filteredSubDivisions.find(
              (sub) => sub.subDivisionCode === selectedSubDivisionCode
            );
            const subDivisionName = subDivision?.subDivisionName || "";
            setOfficeName(subDivisionName.concat(" Sub Division"));
          } else {
            setSubDivisions([]);
          }
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      } catch (error) {
        setSubDivisions([]);
      } finally {
        setLoading(false);
      }
    } else if (selectedSubDivisionCode) {
      setSelectedSubDivision(selectedSubDivisionCode);
      setOfficeCode(selectedSubDivisionCode);
      const subDivisionName =
        filteredSubDivisions.find(
          (sub) => sub.subDivisionCode === selectedSubDivisionCode
        )?.subDivisionName || "";
      setOfficeName(subDivisionName.concat(" Sub Division"));
    } else {
      setSelectedSubDivision("");
      let officeName = getName(
        selectedDivision ? selectedDivision.toString() : offCode.toString(),
        subDivisions
      );
      setOfficeName(officeName.concat(" Division"));
      setOfficeCode(selectedDivision ? selectedDivision : offCode);
    }
  };

  useEffect(() => {
    if (roleTypeName == "Technical") {
      if (offCode) {
        setOfficeCode(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode));
        let offName = getName(
          String(resolveOfficeCodeForAdmin(offCode, selectedAdminCompanyCode)),
          subDivisions
        );
        setOfficeName(offName);
        setHierarchy(offCode.toString().length);
      }
    } else if (roleTypeName == "Commercial") {
      if (cfcLevelId == 1) {
        if (offCode) {
          if (offCode == 10) {
            const effectiveCompany = getEffectiveAdminCompanyCode(
              offCode,
              selectedCompanyCode,
              selectedAdminCompanyCode,
            );
            setOfficeCode(effectiveCompany);
            setOfficeName(getCompanies(String(effectiveCompany)) || "PITC");
          } else {
            setOfficeCode(offCode);
            let offName = getName(offCode, subDivisions);
            setOfficeName(offName);
          }

          setHierarchy(offCode.length);
        }
      } else if (cfcLevelId == 2) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 2));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 3) {
        if (offCode) {
          setOfficeCode(offCode.toString().slice(0, 3));
          let offName = cscID;
          setOfficeName(offName);
          setHierarchy(cfcLevelId);
        }
      } else if (cfcLevelId == 4) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 4));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }else if (cfcLevelId == 5) {
                if (offCode) {
                    setOfficeCode(offCode.toString().slice(0, 5));
                    let offName = cscID;
                    setOfficeName(offName);
                    setHierarchy(cfcLevelId);
                }
            }
    }
  }, [offCode, cfcLevelId, roleTypeName, cscID, selectedAdminCompanyCode, selectedCompanyCode]);

  useEffect(() => {
    if (hierarchy) {
      if (hierarchy == 1 || cfcLevelId === 1) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 2 || cfcLevelId == 2) {
        let circles = subDivisions.reduce((acc, curr) => {
          if (!acc.some((item) => item.circleCode === curr.circleCode)) {
            acc.push({
              circleCode: curr.circleCode,
              circleName: curr.circleName,
              companyCode: curr.companyCode,
            });
          }
          return acc;
        }, []);
        setFilteredCircles(circles);
      } else if (hierarchy == 3 || cfcLevelId == 3) {
        setCircleCode(offCode.slice(0, 3));
        const uniqueDivisions = subDivisions
          .filter((item) => item.circleCode == offCode.slice(0, 3))
          .reduce((acc, item) => {
            if (
              !acc.some(
                (division) => division.divisionCode === item.divisionCode
              )
            ) {
              acc.push({
                divisionCode: item.divisionCode,
                divisionName: item.divisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredDivisions(uniqueDivisions);
      } else if (
        hierarchy == 4 ||
        cfcLevelId == 4 ||
        hierarchy == 5 ||
        cfcLevelId == 5
      ) {
        setSelectedDivision(offCode.slice(0, 4));
        const uniqueSubDivisions = subDivisions
          .filter((item) => item.divisionCode == offCode.slice(0, 4))
          .reduce((acc, item) => {
            if (
              !acc.some((sub) => sub.subDivisionCode === item.subDivisionCode)
            ) {
              acc.push({
                subDivisionCode: item.subDivisionCode,
                subDivisionName: item.subDivisionName,
                companyCode: item.companyCode,
              });
            }
            return acc;
          }, []);
        setFilteredSubDivisions(uniqueSubDivisions);
      }
    }
  }, [hierarchy, cfcLevelId, subDivisions]);

  useEffect(() => {
    if (billingChartYType == 1 && billingChartXType == 1) {
      //Batch and Rupees
      const newCategories = currentBillingStats.batches;
      const newData = convertToMillions(currentBillingStats.amountsBatchWise);
      let dataArray = newData.map((item, index) => ({
        y: item,
        color: index === 0 ? "#006ad1" : "#61affb",
      }));
      setChartOptionsBilling((prevState) => ({
        ...prevState,
        xAxis: {
          ...prevState.xAxis,
          categories: newCategories,
          title: {
            useHTML: true,
            text: '<span style="letter-spacing: 7.5px; color:#BF0F15; ">Batch Number</span>', // Adjust letter-spacing here
            x: 10,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat:
            '<span style="font-size: 12px; color: #000;">Batch: {point.key}</span><br>',
          pointFormatter: function () {
            return `<span style="color:${
              this.color
            }; font-weight: bold;">Amount: ${this.series.name} </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MRs.</span>`;
          },
        },
        plotOptions: {
          ...prevState.plotOptions,
          bar: {
            ...prevState.plotOptions.bar,
            groupPadding: 0.075,
          },
        },
        yAxis: {
          ...prevState.yAxis,
          title: {
            ...prevState.yAxis.title,
            text: "MRs.",
          },
        },
        series: [
          {
            ...prevState.series[0],
            data: dataArray,
            // color: '#ff8995',
          },
        ],
      }));
    } else if (billingChartYType == 1 && billingChartXType == 0) {
      //Batch and Units
      const newCategories = currentBillingStats.batches;
      const newData = convertToMillions(currentBillingStats.unitsBatchWise);
      let dataArray = newData.map((item, index) => ({
        y: item,
        color: index === 0 ? "#eca550" : "#f4c791",
      }));
      setChartOptionsBilling((prevState) => ({
        ...prevState,
        xAxis: {
          ...prevState.xAxis,
          categories: newCategories,
          title: {
            useHTML: true,
            text: '<span style="letter-spacing: 7.5px; color:#BF0F15; ">Batch Number</span>', // Adjust letter-spacing here
            x: 10,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat:
            '<span style="font-size: 12px; color: #000;">Batch: {point.key}</span><br>',
          pointFormatter: function () {
            return `<span style="color:${
              this.color
            }; font-weight: bold;">Amount: ${this.series.name} </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MkWh</span>`;
          },
        },
        plotOptions: {
          ...prevState.plotOptions,
          bar: {
            ...prevState.plotOptions.bar,
            groupPadding: 0.075,
          },
        },
        yAxis: {
          ...prevState.yAxis,
          title: {
            ...prevState.yAxis.title,
            text: "MkWh",
          },
        },
        series: [
          {
            ...prevState.series[0],
            data: dataArray,
          },
        ],
      }));
    } else if (billingChartYType == 0 && billingChartXType == 1) {
      //Category and Rupees
      const newCategories = ["Total", "Dom.", "Com.", "Ind.", "Arg.", "Oth."];
      const newData = convertToMillions(
        currentBillingStats.amountsCategoryWise
      );
      let dataArray = newData.map((item, index) => ({
        y: item,
        color: index === 0 ? "#9954ee" : "#ceadf2",
      }));
      setChartOptionsBilling((prevState) => ({
        ...prevState,
        xAxis: {
          ...prevState.xAxis,
          categories: newCategories,
          title: "",
        },
        yAxis: {
          ...prevState.yAxis,
          title: {
            ...prevState.yAxis.title,
            text: "MRs.",
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat:
            '<span style="font-size: 12px; color: #000;">Category: {point.key}</span><br>',
          pointFormatter: function () {
            return `<span style="color:${
              this.color
            }; font-weight: bold;">Amount: ${this.series.name} </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MRs.</span>`;
          },
        },
        plotOptions: {
          ...prevState.plotOptions,
          bar: {
            ...prevState.plotOptions.bar,
            groupPadding: 0.355,
          },
        },
        series: [
          {
            ...prevState.series[0],
            data: dataArray,
          },
        ],
      }));
    } else if (billingChartYType == 0 && billingChartXType == 0) {
      //Category and Units
      const newCategories = [
        "Total<br>Catg.",
        "Dom.",
        "Com.",
        "Ind.",
        "Arg.",
        "Oth.",
      ];
      const newData = [900, 200, 120, 230, 210, 100];

      setChartOptionsBilling((prevState) => ({
        ...prevState,
        xAxis: {
          ...prevState.xAxis,
          categories: newCategories,
        },
        tooltip: {
          useHTML: true,
          headerFormat:
            '<span style="font-size: 12px; color: #000;">Category: {point.key}</span><br>',
          pointFormatter: function () {
            return `<span style="color:${
              this.color
            }; font-weight: bold;">Amount: ${this.series.name} </span>
                <span style="font-size: 12px;">${Highcharts.numberFormat(
                  this.y,
                  0,
                  ".",
                  ","
                )} MkWh</span>`;
          },
        },
        yAxis: {
          ...prevState.yAxis,
          title: {
            ...prevState.yAxis.title,
            text: "MkWh",
          },
        },
        series: [
          {
            ...prevState.series[0],
            data: newData,
          },
        ],
      }));
    }
  }, [billingChartYType, billingChartXType]);

  function summarizeArray(arr) {
    const result = {
      ASSESS_AGRI: 0,
      ASSESS_COM: 0,
      ASSESS_DOM: 0,
      ASSESS_IND: 0,
      Adjustments: 0,
      AmountAdjusted: 0,
      Batch: "Others", // Static value as required
      BillsIssued: 0,
      CurrentAssessment: 0,
      DetectionAdj: 0,
      DetectionAdjAmount_Rs: 0,
      DetectionAdjUnits_KWH: 0,
      GovtAssessment: 0,
      GovtBilled_KWH: 0,
      NetAmount: 0,
      OpeningBalance: 0,
      PvtUnitBilled_KWH: 0,
      RuralBilled_KWH: 0,
      UnitBilled_KWH: 0,
      UnitsAdjusted_KWH: 0,
      UrbanUnitBilled_KWH: 0,
    };

    arr.forEach((item) => {
      result.ASSESS_AGRI += parseFloat(item.ASSESS_AGRI || 0);
      result.ASSESS_COM += parseFloat(item.ASSESS_COM || 0);
      result.ASSESS_DOM += parseFloat(item.ASSESS_DOM || 0);
      result.ASSESS_IND += parseFloat(item.ASSESS_IND || 0);
      result.Adjustments += parseFloat(item.Adjustments || 0);
      result.AmountAdjusted += parseFloat(item.AmountAdjusted || 0);
      result.BillsIssued += parseFloat(item.BillsIssued || 0);
      result.CurrentAssessment += parseFloat(item.CurrentAssessment || 0);
      result.DetectionAdj += parseFloat(item.DetectionAdj || 0);
      result.DetectionAdjAmount_Rs += parseFloat(
        item.DetectionAdjAmount_Rs || 0
      );
      result.DetectionAdjUnits_KWH += parseFloat(
        item.DetectionAdjUnits_KWH || 0
      );
      result.GovtAssessment += parseFloat(item.GovtAssessment || 0);
      result.GovtBilled_KWH += parseFloat(item.GovtBilled_KWH || 0);
      result.NetAmount += parseFloat(item.NetAmount || 0);
      result.OpeningBalance += parseFloat(item.OpeningBalance || 0);
      result.PvtUnitBilled_KWH += parseFloat(item.PvtUnitBilled_KWH || 0);
      result.RuralBilled_KWH += parseFloat(item.RuralBilled_KWH || 0);
      result.UnitBilled_KWH += parseFloat(item.UnitBilled_KWH || 0);
      result.UnitsAdjusted_KWH += parseFloat(item.UnitsAdjusted_KWH || 0);
      result.UrbanUnitBilled_KWH += parseFloat(item.UrbanUnitBilled_KWH || 0);
    });

    result.ASSESS_AGRI = result.ASSESS_AGRI.toString();
    result.ASSESS_COM = result.ASSESS_COM.toString();
    result.ASSESS_DOM = result.ASSESS_DOM.toString();
    result.ASSESS_IND = result.ASSESS_IND.toString();
    result.Adjustments = result.Adjustments.toString();
    result.AmountAdjusted = result.AmountAdjusted.toString();
    result.BillsIssued = result.BillsIssued.toString();
    result.CurrentAssessment = result.CurrentAssessment.toString();
    result.DetectionAdj = result.DetectionAdj.toString();
    result.DetectionAdjAmount_Rs = result.DetectionAdjAmount_Rs.toString();
    result.DetectionAdjUnits_KWH = result.DetectionAdjUnits_KWH.toString();
    result.GovtAssessment = result.GovtAssessment.toString();
    result.GovtBilled_KWH = result.GovtBilled_KWH.toString();
    result.NetAmount = result.NetAmount.toString();
    result.OpeningBalance = result.OpeningBalance.toString();
    result.PvtUnitBilled_KWH = result.PvtUnitBilled_KWH.toString();
    result.RuralBilled_KWH = result.RuralBilled_KWH.toString();
    result.UnitBilled_KWH = result.UnitBilled_KWH.toString();
    result.UnitsAdjusted_KWH = result.UnitsAdjusted_KWH.toString();
    result.UrbanUnitBilled_KWH = result.UrbanUnitBilled_KWH.toString();

    return result;
  }

  function formatToMillions(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2, // Fixed to 2 decimal places
      maximumFractionDigits: 2,
    }).format(value / Math.pow(10, 6)); // Convert value to millions
  }
  const sumOpeningBalance = data.reduce((total, batch) => {
    return batch.OPENINGBALANCE;
  }, 0);

  const sumAssessGovt = data.reduce((total, batch) => {
    return total + parseFloat(batch.GOVTASSESSMENT);
  }, 0);

  const sumAssessCurrent = data.reduce((total, batch) => {
    return total + parseFloat(batch.CURRENTASSESSMENT);
  }, 0);

  const sumNetAmount = data.reduce((total, batch) => {
    return total + parseFloat(batch.NETAMOUNT);
  }, 0);

  const sumDaily = data.reduce((total, batch) => {
    return total + parseFloat(batch.DAILYAMOUNTPOSTED);
  }, 0);

  const sumOnline = data.reduce((total, batch) => {
    return total + parseFloat(batch.ONLINEAMOUNTPOSTED);
  }, 0);

  const sumTotal = data.reduce((total, batch) => {
    return total + parseFloat(batch.TOTALAMOUNTPOSTED);
  }, 0);
  const sumAdv = data.reduce((total, batch) => {
    return total + parseFloat(batch.ADVANCEPAYMENT);
  }, 0);
  const sumPdisc = data.reduce((total, batch) => {
    return total + parseFloat(batch.PDISCPAYMENT);
  }, 0);
  const sumRealGov = data.reduce((total, batch) => {
    return total + parseFloat(batch.GOVTPAYMENT);
  }, 0);
  const sumTubeWell = data.reduce((total, batch) => {
    return total + parseFloat(batch.TUBEWELLPAYMENT);
  }, 0);
  const sumRcoFee = data.reduce((total, batch) => {
    return total + parseFloat(batch.RCOFEE);
  }, 0);

  const sumAssessPrivate = data.reduce((total, batch) => {
    return (
      total +
      (parseFloat(batch.CURRENTASSESSMENT) - parseFloat(batch.GOVTASSESSMENT))
    );
  }, 0);

  const sumTotalRealization = data.reduce((total, batch) => {
    return (
      total +
      parseFloat(batch.DAILYAMOUNTPOSTED || 0) +
      parseFloat(batch.ONLINEAMOUNTPOSTED || 0) +
      parseFloat(batch.PDISCPAYMENT || 0) +
      parseFloat(batch.GOVTPAYMENT || 0) +
      parseFloat(batch.TUBEWELLPAYMENT || 0) +
      parseFloat(batch.RCOFEE || 0) +
      parseFloat(batch.TOTALAMOUNTPOSTED || 0) +
      parseFloat(batch.ADVANCEPAYMENT || 0)
    );
  }, 0);

  useEffect(() => {
    if (currentBillingStats.batches != []) {
      const newCategories = currentBillingStats.batches;
      const newData = convertToMillions(currentBillingStats.amountsBatchWise);
      let dataArray = newData.map((item, index) => ({
        y: item,
        color: index === 0 ? "#006ad1" : "#61affb",
      }));
      setChartOptionsBilling((prevState) => ({
        ...prevState,
        xAxis: {
          ...prevState.xAxis,
          categories: newCategories,
        },
        yAxis: {
          ...prevState.yAxis,
          title: {
            ...prevState.yAxis.title,
            text: "MRs.",
          },
        },
        plotOptions: {
          ...prevState.plotOptions,
          bar: {
            ...prevState.plotOptions.bar,
            groupPadding: 0.075,
          },
        },
        series: [
          {
            ...prevState.series[0],
            data: dataArray,
          },
        ],
      }));
    }
  }, [currentBillingStats]);

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const [billingReportPopup, setBillingReportPopup] = useState(false);

  const getLogo = (code) => {
    switch (code) {
      case "10":
        return pitcLogo;
      case "11":
        return LESCOLOGO;
      case "12":
        return GEPCOLOGO;
      case "13":
        return FESCOLOGO;
      case "14":
        return IESCOLOGO;
      case "15":
        return MEPCOLOGO;
      case "26":
        return PESCOLOGO;
      case "27":
        return HAZECOLOGO;
      case "37":
        return HESCOLOGO;
      case "38":
        return SEPCOLOGO;
      case "48":
        return QESCOLOGO;
      case "59":
        return TESCOLOGO;
      default:
        return MEPCOLOGO;
    }
  };
  const getCompanies = (code) => {
    switch (code) {
      case "10":
        return "Power Information Technology Company";
      case "11":
        return "Lahore Electric Supply Company";
      case "12":
        return "Gujranwala Electric Power Company";
      case "13":
        return "Faisalabad Electric Supply Company";
      case "14":
        return "Islamabad Electric Supply Company";
      case "15":
        return "Multan Electric Power Company";
      case "26":
        return "Peshawar Electric Supply Company";
      case "27":
        return "Hazara Electric Supply Company";
      case "38":
        return "Sukkur Electric Power Company";
      case "37":
        return "Hyderabad Electric Supply Company";
      case "48":
        return "Quetta Electric Supply Company";
      case "59":
        return "Tribal Electric Supply Company";
    }
  };
  const DownloadPdf = async (print) => {
    return new Promise((resolve, reject) => {
      let offName = officeName;
      let dateToPrint = convertDate(new Date());
      const title = previousMonth;
      const headers = [
        [
          { content: "Feeders", rowSpan: 2, valign: "middle" },
          { content: `Current Month - ${String(previousMonth)}`, colSpan: 4 },
          { content: "Progressive", colSpan: 4 },
        ],
        [
          { content: "Units Received", styles: { halign: "left" } },
          { content: "Units Billed", styles: { halign: "left" } },
          { content: "Units Lost", styles: { halign: "left" } },
          { content: "%Age Loss", styles: { halign: "left" } },
          { content: "Units Received", styles: { halign: "left" } },
          { content: "Units Billed", styles: { halign: "left" } },
          { content: "Units Lost", styles: { halign: "left" } },
          { content: "%Age Loss", styles: { halign: "left" } },
        ],
      ];

      const bodyData = [];
      let dataAvailable = false;

      // Process reportData
      if (reportData.length === 0) {
        // If no data, push a "No Data Found" row with styles
        bodyData.push([
          {
            content: "No Data Found",
            colSpan: 9,
            styles: {
              halign: "center",
              fontSize: 12,
              fontStyle: "bold",
              fillColor: [255, 255, 255],
              textColor: [255, 0, 0], // Red color for the message
            },
          },
        ]);
      } else {
        // Sort data and map to rows
        reportData
          .sort(
            (a, b) => (b.ProgCurLoss.uLost || 0) - (a.ProgCurLoss.uLost || 0)
          ) // Sort by uLost in descending order
          .forEach((item) => {
            dataAvailable = true; // Data exists
            bodyData.push([
              { content: item.feederName || "All", styles: { halign: "left" } },
              {
                content: formatNumberWithCommas(
                  item.MonthlyCurLoss.uReceived || "-"
                ),
                styles: { halign: "left" },
              },
              {
                content: formatNumberWithCommas(
                  item.MonthlyCurLoss.uBilled || "-"
                ),
                styles: { halign: "left" },
              },
              {
                content: formatNumberWithCommas(
                  item.MonthlyCurLoss.uLost || "-"
                ),
                styles: { halign: "left" },
              },
              {
                content: (item.MonthlyCurLoss.percentLost || "-") + "%",
                styles: { halign: "left" },
              },
              {
                content: formatNumberWithCommas(
                  item.ProgCurLoss.uReceived || "-"
                ),
                styles: { halign: "left" },
              },
              {
                content: formatNumberWithCommas(
                  item.ProgCurLoss.uBilled || "-"
                ),
                styles: { halign: "left" },
              },
              {
                content: formatNumberWithCommas(item.ProgCurLoss.uLost || "-"),
                styles: { halign: "left" },
              },
              {
                content: (item.ProgCurLoss.percentLost || "-") + "%",
                styles: { halign: "left" },
              },
            ]);
          });
      }

      // Example usage with jsPDF (if needed)
      if (!dataAvailable) {
      } else {
      }

      // Now, `bodyData` can be passed to your table rendering logic

      // Total row calculation
      const totalRow =
        reportData.length !== 0
          ? [
              "Total",
              formatNumberWithCommas(totalMonthlyCurLossUReceived),
              formatNumberWithCommas(totalMonthlyCurLossUBilled),
              formatNumberWithCommas(totalMonthlyCurLossULost),
              CurrentPercentageLoss.toFixed(2) + "%",
              formatNumberWithCommas(totalProgCurLossUReceived),
              formatNumberWithCommas(totalProgCurLossUBilled),
              formatNumberWithCommas(totalProgCurLossULost),
              ProgressivePercentageLoss.toFixed(2) + "%",
            ]
          : [];

      bodyData.push(totalRow); // Add total row to the body

      // Create a new jsPDF instance
      const pdf = new jsPDF("landscape", "mm", "a4", { compressPdf: true });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const logoWidth =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 25
          : 30;
      const logoHeight =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 20
          : 10;
      pdf.addImage(getLogo(companyCode), "PNG", 15, 5, logoWidth, logoHeight);

      const eOpsLogoWidth = 20;
      const eOpsLogoHeight = 8;
      const eOpsLogoXPosition =
        companyCode === "12" ||
        companyCode === "13" ||
        companyCode === "11" ||
        companyCode === "16" ||
        companyCode === "27" ||
        companyCode === "48" ||
        (companyCode === "59") | (companyCode === "27")
          ? 43
          : 17;
      pdf.addImage(
        eOpsLogo,
        "PNG",
        eOpsLogoXPosition,
        companyCode === "12" ||
          companyCode === "13" ||
          companyCode === "11" ||
          companyCode === "16" ||
          companyCode === "27" ||
          companyCode === "48" ||
          (companyCode === "59") | (companyCode === "27")
          ? 12
          : 17,
        eOpsLogoWidth,
        eOpsLogoHeight
      );

      pdf.setFontSize(10);
      pdf.text(convertDatewithTime(new Date()), pageWidth - 65, 12);
      pdf.text("Name: " + name, pageWidth - 65, 17);
      pdf.text("Designation: " + roleName, pageWidth - 65, 22);

      pdf.setFontSize(12);
      pdf.text(getCompanies(companyCode), pageWidth / 2, 12, {
        align: "center",
      });
      pdf.text(`Feeder Losses Report`, pageWidth / 2, 18, { align: "center" });
      pdf.setFontSize(10); // Set the font size
      pdf.text(
        `Feeder Losses Report for ${officeName} of ${title}`,
        pageWidth / 2,
        25,
        { align: "center" }
      );

      // Add table to PDF using autoTable
      pdf.autoTable({
        startY: 28,
        head: headers,
        body: bodyData,
        styles: {
          cellPadding: 1,
          fontSize: 8,
          halign: "center", // Default alignment for all cells
        },
        headStyles: {
          fontStyle: "bold",
          halign: "center", // Center-align header content
          valign: "middle", // Vertically align to the middle
        },
        columnStyles: {
          0: { cellWidth: 30, halign: "left" }, // Feeder name
          1: { cellWidth: 30, halign: "left" }, // Units Received
          2: { cellWidth: 30, halign: "left" }, // Units Billed
          3: { cellWidth: 30, halign: "left" }, // Units Lost
          4: { cellWidth: 30, halign: "left" }, // Percentage Loss
          5: { cellWidth: 30, halign: "left" }, // Units Received (Progressive)
          6: { cellWidth: 30, halign: "left" }, // Units Billed (Progressive)
          7: { cellWidth: 30, halign: "left" }, // Units Lost (Progressive)
          8: { cellWidth: 30, halign: "left" }, // Percentage Loss (Progressive)
        },
        bodyStyles: {
          fontSize: 8,
          halign: "center", // Default alignment for body cells
        },
        didDrawCell: (data) => {
          // Style the total row
          if (data.row.index === bodyData.length - 1) {
            data.cell.styles.halign = "left"; // Left-align the cell
            data.cell.styles.fillColor = [255, 255, 0]; // Yellow background
            data.cell.styles.fontStyle = "bold"; // Bold font for total row
            data.cell.styles.fontSize = 10; // Larger font size for total row
          }
        },
      });

      // Add watermark to all pages
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        const pageNumberText = `Page ${i} of ${totalPages}`;
        pdf.setFontSize(10);
        pdf.text(pageNumberText, pageWidth - 45, pageHeight - 10);
      }

      // Save the PDF
      if (print) {
        openJsPdfInNewTab(pdf, `${offName} - ${dateToPrint} - Feeder-Losses-Report.pdf`);
      } else {
        resolve(pdf);
      }
    });
  };

  const exportToExcel = () => {
    let offName = officeName;
    let dateToPrint = convertDate(new Date());
    const wb = XLSX.utils.table_to_book(tableRef.current, { sheet: "Sheet1" });
    boldDomTheadRows(wb.Sheets[wb.SheetNames[0]], tableRef.current, 0);
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout]),
      `${offName} - ${dateToPrint} - Feeder-Losses-Report.xlsx`
    );
  };

  const printPDF = async () => {
    let pdf = await DownloadPdf(false);
    const pdfUrl = pdf.output("bloburl");

    // Create an iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);

    // Create a cancel button
    const cancelButton = document.createElement("button");
    cancelButton.textContent = "Cancel";
    cancelButton.style.position = "fixed";
    cancelButton.style.top = "20px";
    cancelButton.style.right = "20px";
    cancelButton.style.padding = "10px 20px";
    cancelButton.style.backgroundColor = "#ff4d4d";
    cancelButton.style.color = "white";
    cancelButton.style.border = "none";
    cancelButton.style.borderRadius = "5px";
    cancelButton.style.cursor = "pointer";
    document.body.appendChild(cancelButton);

    // Print the PDF when the iframe loads
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    };

    // Remove iframe and cancel button when cancel button is clicked
    cancelButton.addEventListener("click", () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
      if (cancelButton.parentNode) {
        document.body.removeChild(cancelButton);
      }
    });
  };

  function formatDecimalPoints(value) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  }

  function convertToMillion(openingBalance) {
    return (openingBalance / Math.pow(10, 6)).toFixed(2);
  }
  function getCurrentDateFormatted(date) {
    const day = String(date.getDate()).padStart(2, "0");
    const options = { month: "short" };
    const month = date.toLocaleString("en-US", options);
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  }
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth(); // 0-indexed (January is 0)

  // List of all months
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Generate years dropdown (last 10 years)
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  // State for selected year and month
  const [selectedYear, setSelectedYear] = useState(String(currentYear));
  const [selectedMonth, setSelectedMonth] = useState(
    currentMonth === 0 ? months[11] : months[currentMonth - 1] // Default to the previous month
  ); // Default to the previous month

  const [formattedDate, setFormattedDate] = useState(getCurrentDate()); // State to store the formatted date

  // Get months to display based on the selected year
  const getFilteredMonths = () => {
    if (selectedYear === String(currentYear)) {
      // If the selected year is current year, show months from January to the previous month
      return months.slice(0, currentMonth); // Only up to the previous month
    }
    return months; // All months for other years
  };

  // Handle Year Change
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    // If the selected year is the current year, ensure the selected month is not in the future
    if (year === String(currentYear)) {
      // If the current year is selected, set the month to the previous month (if not already set)
      if (months.indexOf(selectedMonth) >= currentMonth) {
        setSelectedMonth(months[currentMonth - 1]); // Set to the previous month
      }
    } else {
      // For other years, set January as the default
      setSelectedMonth("January");
    }
  };

  // Handle Month Change
  const handleMonthChange = (e) => {
    setSelectedMonth(e.target.value);
  };

  // Effect to set default year and month
  useEffect(() => {
    // If the selected year is the current year and the selected month is before the current month,
    // automatically set the selected month to the previous month.
    if (
      selectedYear === String(currentYear) &&
      months.indexOf(selectedMonth) >= currentMonth
    ) {
      setSelectedMonth(months[currentMonth - 1]); // Set to the previous month if the user selects a future month in current year
    }
  }, [selectedYear, currentMonth, selectedMonth]);

  // Function to format the selected year and month
  const formatSelectedDate = () => {
    if (!selectedYear || !selectedMonth) return "None";

    const year = String(selectedYear).slice(-2); // Get the last 2 digits of the year
    const month = selectedMonth.slice(0, 3); // Get the first 3 letters of the month
    const day = "01";
    return `${day}-${month}-${year}`; // Combine them in the format "-Nov-24"
  };

  // Update formatted date whenever the year or month changes
  useEffect(() => {
    const newFormattedDate = formatSelectedDate();
    setFormattedDate(newFormattedDate); // Set the new formatted date in state
    if (newFormattedDate) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const [day, month, year] = newFormattedDate.split("-"); // Split the date into components
      let monthIndex = months.indexOf(month); // Get the index of the current month
      let previousYear = parseInt(year, 10); // Parse the year as a number

      // Calculate the previous month and year
      if (monthIndex === 0) {
        monthIndex = 11; // December
        previousYear -= 1; // Go to the previous year
      } else {
        monthIndex -= 1;
      }

      const previousMonthFormatted = `${months[monthIndex]}-${previousYear
        .toString()
        .slice(-2)}`;
      setPreviousMonth(previousMonthFormatted);
    }
  }, [selectedYear, selectedMonth]);
  const getStats = async (officeCode, formattedDate) => {
    try {
      setLoading(true);
      if (offCode && formattedDate) {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          officeCode: officeCode,
          date: formattedDate,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        fetch(cfpBaseUrl + "dashBoard/technicalLoses", requestOptions)
          .then((response) => response.json())
          .then((result) => {
            if (result.status == 200) {
              const filteredData = result.data.filter(
                (item) => item.SDivCode == officeCode
              );
              if (filteredData) {
                setReportData(filteredData);
                setLoading(false);
              } else {
                setReportData([]);
                setLoading(false);
              }
            } else {
              setReportData([]);
              setLoading(false);
            }
          })
          .catch(() => {});
      }
    } catch (e) {
    }
  };

  const reportDataArray = reportData || [];
  const totalMonthlyCurLossUReceived = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.MonthlyCurLoss.uReceived) || 0),
    0
  );
  const totalMonthlyCurLossUBilled = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.MonthlyCurLoss.uBilled) || 0),
    0
  );
  const totalMonthlyCurLossULost = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.MonthlyCurLoss.uLost) || 0),
    0
  );
  const totalMonthlyCurLossPercentLost = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.MonthlyCurLoss.percentLost) || 0),
    0
  );
  const totalProgCurLossUReceived = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.ProgCurLoss.uReceived) || 0),
    0
  );
  const totalProgCurLossUBilled = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.ProgCurLoss.uBilled) || 0),
    0
  );
  const totalProgCurLossULost = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.ProgCurLoss.uLost) || 0),
    0
  );
  const totalProgCurLossPercentLost = reportDataArray.reduce(
    (acc, item) => acc + (Number(item.ProgCurLoss.percentLost) || 0),
    0
  );
  const CurrentPercentageLoss =
    (totalMonthlyCurLossULost / totalMonthlyCurLossUReceived) * 100;
  const ProgressivePercentageLoss =
    (totalProgCurLossULost / totalProgCurLossUReceived) * 100;
  const period = reportData.map((item, index) => item.MonthlyCurLoss.Period)[0];
  const formattedPeriod = period ? period.split("-").slice(1).join("-") : "-";

  const currentFilters = {
    officeCode,
    formattedDate,
    selectedYear,
    selectedMonth,
  };

  useEffect(() => {
    if (lastAppliedFilters === null) {
      setIsGoDisabled(false);
      return;
    }

    const hasChanged =
      JSON.stringify(currentFilters) !== JSON.stringify(lastAppliedFilters);
    setIsGoDisabled(!hasChanged);
  }, [officeCode, formattedDate, selectedYear, selectedMonth, lastAppliedFilters]);

  const handleGoClick = () => {
    const reportOfficeCode = resolveReportGoOfficeCode({
      code,
      officeCode,
      selectedCompanyCode,
      selectedAdminCompanyCode,
      circleCode,
      selectedDivision,
      selectedSubDivision,
    });
    getStats(reportOfficeCode, formattedDate);

    setLastAppliedFilters({ ...currentFilters });

    setIsGoDisabled(true);
    setMobileFilterOpen(false);
  };

   const noDataAvailable = () => {
    alert("No data available to export or print.");
  };

  const FilterFieldLabel = ({ htmlFor, children }) => (
    <Typography
      component="label"
      variant="body2"
      htmlFor={htmlFor}
      sx={{
        fontWeight: 600,
        color: "text.secondary",
        display: "block",
        mb: 0.5,
        lineHeight: 1.35,
      }}
    >
      {children}
    </Typography>
  );

  const feederBannerPeriod = formattedDate
    ? formattedDate.split("-").slice(1).join("-")
    : "-";

  const tableCaptionText = `Feeder Losses Report for ${officeName || "—"} of ${feederBannerPeriod}`;

  const renderFilters = ({ showGo = false } = {}) => (
    <Grid
      container
      spacing={2}
      alignItems="flex-start"
      className="coa-filters-grid-wrap"
    >
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="fl-year">Year</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="fl-year"
              value={selectedYear}
              onChange={(e) => handleYearChange(e)}
            >
              {years.map((year, index) => (
                <MenuItem key={index} value={String(year)}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <Stack spacing={0.5}>
          <FilterFieldLabel htmlFor="fl-month">Month</FilterFieldLabel>
          <FormControl fullWidth size="small" variant="outlined">
            <Select
              id="fl-month"
              value={selectedMonth}
              onChange={(e) => handleMonthChange(e)}
              disabled={!selectedYear}
            >
              {getFilteredMonths().map((month, index) => (
                <MenuItem key={index} value={month}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Grid>
      {code == 10 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="fl-company">Company</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="fl-company"
                displayEmpty
                value={selectedCompanyCode || ""}
                onChange={handleChangeCompany}
              >
                <MenuItem value="">
                  <em>Select Company</em>
                </MenuItem>
                {getDiscoCompanyMenuItems(selectedCompanyCode)}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 2 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="fl-circle">Circle</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="fl-circle"
                displayEmpty
                value={
                  circleCode === "" ||
                  circleCode === undefined ||
                  circleCode === null
                    ? ""
                    : circleCode
                }
                onChange={handleCircleChange}
                renderValue={(v) => renderCircleValue(v, filteredCircles)}
              >
                <MenuItem value="">
                  <em>All Circle</em>
                </MenuItem>
                {filteredCircles.map((circle) => (
                  <MenuItem key={circle.circleCode} value={circle.circleCode}>
                    {circle.circleName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 3 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="fl-division">Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="fl-division"
                displayEmpty
                value={
                  selectedDivision === "" ||
                  selectedDivision === undefined ||
                  selectedDivision === null
                    ? ""
                    : selectedDivision
                }
                onChange={handleDivisionChange}
                disabled={!circleCode}
                renderValue={(v) => renderDivisionValue(v, filteredDivisions)}
              >
                <MenuItem value="">
                  <em>All Division</em>
                </MenuItem>
                {filteredDivisions.map((division) => (
                  <MenuItem
                    key={division.divisionCode}
                    value={division.divisionCode}
                  >
                    {division.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {hierarchy <= 4 && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5}>
            <FilterFieldLabel htmlFor="fl-subdiv">Sub-Division</FilterFieldLabel>
            <FormControl fullWidth size="small" variant="outlined">
              <Select
                id="fl-subdiv"
                displayEmpty
                value={
                  selectedSubDivision === "" ||
                  selectedSubDivision === undefined ||
                  selectedSubDivision === null
                    ? ""
                    : selectedSubDivision
                }
                onChange={handleSubDivisionChange}
                disabled={!selectedDivision}
                renderValue={(v) =>
                  renderSubDivisionValue(v, filteredSubDivisions)
                }
              >
                <MenuItem value="">
                  <em>All Sub-Division</em>
                </MenuItem>
                {filteredSubDivisions.map((subDivision) => (
                  <MenuItem
                    key={subDivision.subDivisionCode}
                    value={subDivision.subDivisionCode}
                  >
                    {subDivision.subDivisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Grid>
      )}
      {showGo && (
        <Grid item xs={12} sm={6} md={2}>
          <Stack spacing={0.5} sx={{ pt: "2px" }}>
            <Box
              aria-hidden
              sx={{
                height: "1.35rem",
                mb: 0.5,
                lineHeight: 1.35,
              }}
            />
            <Button
              id="fl-go-btn"
              fullWidth
              variant="contained"
              disableElevation
              className="coa-go-btn"
              onClick={handleGoClick}
              disabled={isGoDisabled || loading}
            >
              GO
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );

  return (
    <>
      <Box className="form-box rpt-page coa-status-report feeder-losses-report-page">
        <div className="coa-layout">
          <header className="coa-page-header">
            <h1 className="coa-page-title">Feeder Losses Report</h1>
          </header>

          <div className="coa-toolbar-stack">
            <Paper
              variant="outlined"
              className="coa-card coa-card--filters"
              sx={{
                p: 2,
                width: "100%",
                bgcolor: "#fff",
                borderRadius: 2,
                borderColor: "divider",
              }}
            >
              <div
                className={
                  isMdUp ? "coa-filters coa-filters--mui-grid" : "coa-filters"
                }
              >
                {isMdUp ? (
                  renderFilters({ showGo: true })
                ) : (
                  <p className="coa-filters-hint">
                    Tap <strong>Filters</strong> to set period and office, then tap{" "}
                    <strong>GO</strong>.
                  </p>
                )}
              </div>

              <Stack
                direction="row"
                flexWrap="wrap"
                alignItems="center"
                justifyContent={{ xs: "flex-start", md: "flex-end" }}
                spacing={1}
                className="coa-export-strip"
                sx={{
                  pt: 2,
                  mt: 2,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  gap: 1,
                }}
              >
                {!isMdUp && (
                  <Tooltip title="Filters">
                    <IconButton
                      color="primary"
                      onClick={() => setMobileFilterOpen(true)}
                      aria-label="Open filters"
                      size="small"
                    >
                      <FilterListIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {!isMdUp && (
                  <Button
                    variant="contained"
                    disableElevation
                    className="coa-go-btn"
                    size="small"
                    onClick={handleGoClick}
                    disabled={isGoDisabled || loading}
                  >
                    GO
                  </Button>
                )}
                <ReportExportButtons
                  isEmpty={reportData.length === 0}
                  onEmpty={noDataAvailable}
                  onPdf={() => DownloadPdf(true)}
                  onExcel={exportToExcel}
                  onPrint={printPDF}
                />
              </Stack>
            </Paper>
          </div>

          <div className="coa-report-banner" role="status">
            {tableCaptionText}
          </div>

          <Box
            className="application-table"
            sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}
          >
            <div className="div-datagrid">
              <div
                className={
                  "coa-table-panel" +
                  (isPhone ? " coa-table-panel--hide-phone" : "")
                }
              >
                <div className="coa-table-scroll" id="pdf-table">
                  <table
                    ref={tableRef}
                    className="coa-data-table table feeder-losses-table"
                  >
                <thead>
                  <tr>
                    <th
                      rowSpan={2}
                      style={{
                        border: "6px solid white",
                        backgroundColor: "#d5e5fc",
                        color: "black",
                        padding: "10px 10px",
                        fontSize: "17px",
                        fontFamily: "Roboto-Medium",
                      }}
                    >
                      Feeders
                    </th>
                    <th
                      colSpan={4}
                      style={{
                        border: "6px solid white",
                        backgroundColor: "#d5e5fc",
                        color: "black",
                        padding: "10px 20px",
                        fontSize: "20px",
                        fontFamily: "Roboto-Medium",
                      }}
                    >
                      Current Month - {previousMonth}{" "}
                    </th>
                    <th
                      colSpan={4}
                      style={{
                        border: "6px solid white",
                        backgroundColor: "#d5e5fc",
                        color: "black",
                        padding: "10px 20px",
                        fontSize: "20px",
                        fontFamily: "Roboto-Medium",
                      }}
                    >
                      Progressive
                    </th>
                  </tr>
                  <tr>
                    <th
                      style={{
                        borderTop: "8px solid white",
                        borderRight: "8px solid white",
                        borderBottom: "8px solid white",
                        borderLeft: "0px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Recieved
                    </th>
                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Billed
                    </th>
                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Lost
                    </th>
                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      %Age Loss
                    </th>
                    <th
                      style={{
                        borderTop: "8px solid white",
                        borderRight: "8px solid white",
                        borderBottom: "8px solid white",
                        borderLeft: "0px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Recieved
                    </th>
                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Billed
                    </th>
                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      Units Lost
                    </th>

                    <th
                      style={{
                        border: "8px solid white",
                        backgroundColor: "#eeeff0",
                        color: "black",
                        fontSize: "15px",
                        fontFamily: "Roboto-Medium",
                        padding: "5px",
                        textAlign: "left",
                      }}
                    >
                      %Age Loss
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr className="coa-loading-row">
                      <td
                        colSpan={9}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <AppLoader />
                        </Box>
                      </td>
                    </tr>
                  ) : reportData.length === 0 ? (
                    <tr className="coa-empty-row">
                      <td
                        colSpan={9}
                        style={{
                          textAlign: "center",
                          padding: "10px",
                          fontWeight: "bold",
                          color: "red",
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    <>
                      {reportData
                        .sort(
                          (a, b) =>
                            (b.ProgCurLoss.uLost || 0) -
                            (a.ProgCurLoss.uLost || 0)
                        ) // Sort by uLost in descending order
                        .map((item, index) => (
                          <tr
                            key={index}
                            style={{ borderBottom: "1px solid #ccc" }}
                          >
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingLeft: "40px",
                              }}
                            >
                              {item.feederName ? item.feederName : "All"}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.MonthlyCurLoss.uReceived || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.MonthlyCurLoss.uBilled || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.MonthlyCurLoss.uLost || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.MonthlyCurLoss.percentLost || "-"
                              )}
                              %
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.ProgCurLoss.uReceived || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.ProgCurLoss.uBilled || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {formatNumberWithCommas(
                                item.ProgCurLoss.uLost || "-"
                              )}
                            </td>
                            <td
                              style={{
                                backgroundColor: "white",
                                textAlign: "Left",
                                fontSize: "14px",
                                paddingRight: "40px",
                              }}
                            >
                              {item.ProgCurLoss.percentLost || "-"}%
                            </td>
                          </tr>
                        ))}
                      <tr
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#fff5c0",
                        }}
                      >
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "17px",
                            paddingLeft: "40px",
                            color: "black",
                            fontWeight: "bold",
                          }}
                        >
                          Total
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalMonthlyCurLossUReceived)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalMonthlyCurLossUBilled)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalMonthlyCurLossULost)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {CurrentPercentageLoss.toFixed(2)}%
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalProgCurLossUReceived)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalProgCurLossUBilled)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {formatNumberWithCommas(totalProgCurLossULost)}
                        </td>
                        <td
                          style={{
                            textAlign: "Left",
                            fontSize: "14px",
                            paddingRight: "40px",
                            fontWeight: "bold",
                          }}
                        >
                          {ProgressivePercentageLoss.toFixed(2)}%
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
                </div>
              </div>
            </div>
          </Box>

          <Drawer
            anchor="left"
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            PaperProps={{
              className: "coa-filter-drawer",
              sx: {
                width: { xs: "100%", sm: 400 },
                maxWidth: "100vw",
                boxSizing: "border-box",
              },
            }}
          >
            <Box
              className="coa-drawer-inner"
              sx={{ p: 2, pb: 3, boxSizing: "border-box" }}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6" component="div">
                  Filters
                </Typography>
                <IconButton
                  aria-label="Close filters"
                  onClick={() => setMobileFilterOpen(false)}
                  edge="end"
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
              {renderFilters({ showGo: true })}
            </Box>
          </Drawer>
        </div>
      </Box>
    </>
  );
};

export default FeederLossesReport;
